import { useEffect } from 'react';
import { useToast } from '../ui/Toast';
import { registerMutationErrorToast } from '../queryClient';

/** Verbindet den globalen Mutations-Fehler-Toast des queryClient mit dem ToastProvider. */
export default function MutationErrorToasts() {
  // `push` ist useCallback-stabil, das Context-Objekt dagegen pro Render neu — deshalb nur `push` als Abhängigkeit.
  const { push } = useToast();
  useEffect(() => registerMutationErrorToast((message) => push({ tone: 'error', message })), [push]);
  return null;
}
